



import { Component, Vue, Prop } from 'vue-property-decorator'
import pages from '@/constants/pages'

@Component({})
export default class CategoryImage extends Vue {
  @Prop(String) src!: string
}
